module.exports = __webpack_public_path__ + "static/media/torneos.870b298f.png";